import { render, staticRenderFns } from "./sim-management.vue?vue&type=template&id=cba6c5c4&"
import script from "./sim-management.vue?vue&type=script&lang=js&"
export * from "./sim-management.vue?vue&type=script&lang=js&"
import style0 from "./sim-management.vue?vue&type=style&index=0&id=cba6c5c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports